import getOptionAttributesByElementId from './get-option-attributes-by-element-id';

const mappingOptionElementIdsToAttributes = (option) =>
  option.elementIds.reduce(
    (acc, elementId) => ({
      ...acc,
      [elementId]: getOptionAttributesByElementId(option, elementId),
    }),
    {}
  );

export default mappingOptionElementIdsToAttributes;
